import { isPresent } from "@apl-digital/utils";
import { add } from "date-fns";
import { deepEqual } from "fast-equals";

import { clearStorage, setStorage, StorageKey } from "@/constants/storage";
import { hasData } from "@/store/apiRequestStatusMachine";
import type { AppStartListening } from "@/store/listenerMiddleware";

import { clearFormContactInfo, selectFormContactInfo } from "./slice";

export const addContactInfoListeneres = (startListening: AppStartListening) => {
  startListening({
    predicate: (_action, currentState, previousState) =>
      !deepEqual(
        selectFormContactInfo(previousState),
        selectFormContactInfo(currentState),
      ),
    effect: (_action, { getState }) => {
      const contactInfo = selectFormContactInfo(getState());

      if (isPresent(contactInfo)) {
        setStorage(StorageKey.CONTACT_INFO, contactInfo, {
          type: "expiringRecord",
          expiresAt: add(Date.now(), { days: 182 }).getTime(),
        });
      } else {
        clearStorage(StorageKey.CONTACT_INFO);
      }
    },
  });

  startListening({
    predicate: (_action, currentState, previousState) =>
      hasData(previousState.user.userData) &&
      !hasData(currentState.user.userData),
    effect: (_action, { dispatch }) => {
      dispatch(clearFormContactInfo());
    },
  });
};
